import utils from '@/services/utils';

export default {
  // 学科列表
  getSubjects(variables = {}) {
    return utils.get('/api/home/student/test/public/get/projectList', variables);
  },
  /* 单词模块 */
  // 英语单词总览
  getEnglishOverview(variables = {}) {
    return utils.get('/api/home/student/statistic/template1/get/reportOverall', variables);
  },
  // 英语单词试卷统计
  getTestResults(variables = {}) {
    return utils.get('/api/home/student/statistic/template1/get/examinationStatistic', variables, true);
  },
  // 一周内单词数量
  getWeekWords(variables = {}) {
    return utils.get('/api/home/student/statistic/template1/get/weekWordNumStatistic', variables);
  },
  // 一周内学习时间
  getWeekWordTime(variables = {}) {
    return utils.get('/api/home/student/statistic/template1/get/weekLearnTimeStatistic', variables);
  },
  // 奖状
  getTestTrophy(variables = {}) {
    return utils.get('/api/home/student/statistic/template1/get/beforeAfterTestTrophy', variables);
  },
  // 试卷详情
  getEexamDetails(variables = {}) {
    return utils.get('/api/home/student/statistic/template1/get/examinationStatisticDetails', variables);
  },


  /* 史地生模块 */
  // 史地生总览
  getOtherOverview(variables = {}) {
    return utils.get('/api/home/student/statistic/template3/get/reportOverall', variables);
  },
  // 史地生学科书籍列表
  getBooks(variables = {}) {
    return utils.get('/api/home/student/statistic/template3/get/projectBookList', variables);
  },
  // 史地生试卷列表统计
  getTestsStatistic(variables = {}) {
    return utils.get('/api/home/student/statistic/template3/get/testListStatistic', variables, true);
  },
  // 史地生近7次考试统计
  getSevenExamRecord(variables = {}) {
    return utils.get('/api/home/student/statistic/template3/get/latelySevenTestStatistic', variables);
  },
  // 史地生试卷列表统计-查看报告
  getTestStatisticReport(variables = {}) {
    return utils.get('/api/home/student/statistic/template3/get/testStatisticReport', variables);
  },

  /* 易错集 */
  // 试卷类型（易错集|阶段测试）
  getTestStatisticReportTypes() {
    return utils.get('/api/home/student/statistic/test/get/testStatisticReportTypeList');
  },
  // 易错集试卷列表统计
  getTestStatisticReports(variables = {}) {
    return utils.get('/api/home/student/statistic/test/get/testStatisticReportList', variables, true);
  },
  // 会考类查看报告
  getDsTypeTestStatisticReport(variables = {}) {
    return utils.get('/api/home/student/statistic/test/get/dsTypeTestStatisticReport', variables);
  },
  // 其他类查看报告
  getOtherTypeTestStatisticReport(variables = {}) {
    return utils.get('/api/home/student/statistic/test/get/otherTypeTestStatisticReport', variables);
  },

  /* 自由组合 */
  // 一周内学习时间统计
  getWeekLearnTime(variables = {}) {
    return utils.get('/api/home/student/statistic/template2/get/weekLearnTimeStatistic', variables, true);
  },
  // 一周内错题统计
  getWeekWrong(variables = {}) {
    return utils.get('/api/home/student/statistic/template2/get/weekWrongStatistic', variables, true);
  },
  // 近7次考试统计
  getLatelySevenTest(variables = {}) {
    return utils.get('/api/home/student/statistic/template2/get/latelySevenTestStatistic', variables, true);
  },
};
